//frontend/src/components/OrdersPage/OrderDocumentsPage/OrderDocumentsPage.jsx

import React, { useEffect, useState } from "react";
import { authFetch } from "../../api/api"; 
import { useParams } from "react-router-dom";
import UploadDocumentModal from "./UploadDocumentModal";
import Button from "../../UI/Button";
import ConfirmModal from "../../UI/ConfirmModal";

// Импортируем генераторы для HTML-документов (если они еще нужны)
import { 
  generateInvoice, 
  generatePackingList, 
  generateDelayNotice, 
  generateUPD,
  generateCommissionAgreement 
} from "./documentTemplates";

const BASE_URL = process.env.REACT_APP_DJANGO_BACKEND;

export default function OrderDocumentsPage() {
  const { id } = useParams();
  const orderId = id;

  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [generating, setGenerating] = useState(false); // Стейт для кнопки генерации
  const [showModal, setShowModal] = useState(false);

  // 💥 delete modal state
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [documentToDelete, setDocumentToDelete] = useState(null);

  // 💥 Мок-данные заказа (для HTML-шаблонов)
  const [orderData, setOrderData] = useState({
    id: orderId,
    contract_no: "IEANI20260514",
    invoice_no: "IEANI20260514-2",
    date: new Date().toISOString().split('T')[0],
    client: {
      name: "Армянинов Никита Игоревич",
      official_name: "ИП Армянинов Никита Игоревич",
      address: "21A Sovetskaya ulitsa, Apt 25, Izhevsk"
    },
    items: [
      { description: "3 ml glass bottles (complete set)", qty: 2100000, unit_price: 0.244419, amount: 513279.93, gw: 13749.93, nw: 12180, meas: 46.1 },
      { description: "5 ml glass bottles (complete set)", qty: 20000, unit_price: 0.250238, amount: 5004.77, gw: 176.69, nw: 156, meas: 0.5 },
      { description: "10 ml glass bottles (complete set)", qty: 110000, unit_price: 0.256058, amount: 28166.38, gw: 1305.38, nw: 1166, meas: 2.5 }
    ],
    total_amount: 610620.41,
    total_qty: 2230000,
    total_gw: 15232.00,
    total_nw: 13502,
  });

  useEffect(() => {
    if (orderId) fetchDocuments();
  }, [orderId]);

  const fetchDocuments = async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${BASE_URL}/api/documents/`);
      if (!res.ok) throw new Error("Ошибка загрузки");
      const data = await res.json();
      const filtered = data.filter((doc) => Number(doc.order) === Number(orderId));
      setDocuments(filtered);
    } catch (error) {
      console.error("Ошибка загрузки документов:", error);
    } finally {
      setLoading(false);
    }
  };

  // 💥 Генерация документов (СМГС - с бэкенда, остальные - HTML)
  const handleGenerateDocument = async (e) => {
    const docType = e.target.value;
    if (!docType) return;
    
    // Сбрасываем select обратно
    e.target.value = "";

    // --- ГЕНЕРАЦИЯ СМГС НА БЭКЕНДЕ (EXCEL) ---
    if (docType === "smgs") {
      try {
        setGenerating(true);
        // Отправляем POST-запрос на создание файла
        const res = await authFetch(
          `${BASE_URL}/api/documents/generate-smgs/${orderId}/`,
          { method: "POST" }
        );
        if (!res.ok) throw new Error("Ошибка генерации");
        
        // Получаем ссылку на готовый файл
        const data = await res.json();
        const fileUrl = data.document.file_url;
        
        // Открываем файл в новой вкладке для скачивания
        window.open(fileUrl, "_blank");
        
        // Обновляем список документов
        await fetchDocuments();
      } catch (error) {
        console.error("Ошибка генерации СМГС:", error);
        alert(error.response?.data?.error || "Ошибка при генерации Excel файла");
      } finally {
        setGenerating(false);
      }
      return;
    }

    // --- ГЕНЕРАЦИЯ HTML ДОКУМЕНТОВ (как было) ---
    let htmlContent = "";
    let fileName = `Document_${orderId}`;

    switch (docType) {
      case "invoice":
        htmlContent = generateInvoice(orderData);
        fileName = `Invoice_${orderData.invoice_no}`;
        break;
      case "packing_list":
        htmlContent = generatePackingList(orderData);
        fileName = `Packing_List_${orderData.invoice_no}`;
        break;
      case "delay_notice":
        htmlContent = generateDelayNotice(orderData);
        fileName = `Delay_Notice_${orderData.contract_no}`;
        break;
      case "upd":
        htmlContent = generateUPD(orderData);
        fileName = `UPD_${orderId}`;
        break;
      case "commission":
        htmlContent = generateCommissionAgreement(orderData);
        fileName = `Commission_Agreement_${orderId}`;
        break;
      default:
        return;
    }

    // Открываем новое окно и пишем туда HTML
    const newWindow = window.open();
    newWindow.document.write(htmlContent);
    newWindow.document.close();
  };

  const openDeleteModal = (doc) => {
    setDocumentToDelete(doc);
    setShowDeleteConfirm(true);
  };

  const handleDelete = async () => {
    if (!documentToDelete) return;
    try {

      const res = await authFetch(`${BASE_URL}/api/documents/${documentToDelete.id}/`, {
        method: "DELETE"
      });
      if (!res.ok) throw new Error("Ошибка удаления");
      
      setDocuments((prev) => prev.filter((d) => d.id !== documentToDelete.id));


      setShowDeleteConfirm(false);
      setDocumentToDelete(null);
    } catch (error) {
      console.error("Ошибка удаления:", error);
      alert("Ошибка удаления документа");
    }
  };

  return (
    <div className="p-6 max-w-5xl mx-auto">
      {/* HEADER */}
      <div className="flex flex-wrap justify-between items-center mb-6 gap-4">
        <h1 className="text-2xl font-bold">Документы заказа #{orderId}</h1>

        <div className="flex gap-3 items-center">
          {/* 💥 Выпадающий список генерации */}
          <select 
            className="border p-2 rounded bg-white cursor-pointer hover:bg-gray-50 disabled:opacity-50"
            onChange={handleGenerateDocument}
            defaultValue=""
            disabled={generating}
          >
            <option value="" disabled>
              {generating ? "Формирование..." : "Сформировать документ..."}
            </option>
            
            <option value="smgs">Ж/Д СМГС Накладная (Excel)</option>
            <option value="invoice">Инвойс (Commercial Invoice)</option>
            <option value="packing_list">Упаковочный лист (Packing List)</option>
            <option value="delay_notice">Уведомление о переносе срока</option>
            <option value="upd">УПД</option>
            <option value="commission">Договор комиссии и отчеты</option>
          </select>

          <Button variant="primary" onClick={() => setShowModal(true)}>
            + Загрузить файл
          </Button>
        </div>
      </div>

      {/* LIST */}
      {loading ? (
        <p>Загрузка...</p>
      ) : (
        <div className="grid gap-4 mt-6">
          {documents.length === 0 && <p className="text-gray-500">Файлов пока нет.</p>}
          
          {documents.map((doc) => (
            <div key={doc.id} className="border p-4 rounded-lg bg-white shadow-sm flex justify-between items-start">
              <div>
                <p className="font-semibold text-gray-800">{doc.comment || "Без комментария"}</p>
                {doc.file_url || doc.file ? (
                  <a 
                    href={doc.file_url || doc.file} 
                    target="_blank" 
                    rel="noreferrer" 
                    className="text-blue-600 text-sm hover:underline mt-1 inline-block"
                  >
                    Открыть файл
                  </a>
                ) : null}
              </div>
              <Button variant="danger" onClick={() => openDeleteModal(doc)}>
                Удалить
              </Button>
            </div>
          ))}
        </div>
      )}

      {/* UPLOAD MODAL */}
      {showModal && (
        <UploadDocumentModal
          orderId={orderId}
          onClose={() => setShowModal(false)}
          onSuccess={() => {
            setShowModal(false);
            fetchDocuments();
          }}
        />
      )}

      {/* 💥 CONFIRM DELETE MODAL */}
      <ConfirmModal
        isOpen={showDeleteConfirm}
        onClose={() => setShowDeleteConfirm(false)}
        onConfirm={handleDelete}
        title="Удаление документа"
        description={`Удалить документ "${documentToDelete?.comment || "без комментария"}"?`}
        confirmText="Удалить"
      />
    </div>
  );
}